import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const EyeIcon = createIcon({
  displayName: 'EyeIcon',
  path: [
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M19.25 12C19.25 13 17.5 18.25 12 18.25C6.5 18.25 4.75 13 4.75 12C4.75 11 6.5 5.75 12 5.75C17.5 5.75 19.25 11 19.25 12Z'
    />,
    <circle
      cx='12'
      cy='12'
      r='2.25'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  ],
  defaultProps: defaultProps
})
